import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import MemberPortalSubheader from "components/Subheader/MemberPortalSubheader";
import MemberBreadcrumbs from "features/memberPortal/common/Breadcrumbs/MemberBreadcrumbs.breadcrumbs";
import { useAuth } from "hooks/useAuth";
import { usePageTitle } from "hooks/usePageTitle";

import LegacyRoutes from "./siteWrapper/Main/LegacyRoutes";
import StyledMain from "./siteWrapper/Main/StyledMain";
import Sidebar from "./siteWrapper/Sidebar/Sidebar";

const Admin = () => {
  const navigate = useNavigate();

  const { authToken, currentUser, permissions } = useAuth();

  const [selectedDashBoard, setSelectedDashBoard] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // TODO: handle this at route level
  useEffect(() => {
    if (!authToken) {
      navigate("/login/");
    }
    if (permissions.role_type === AUTH_ROLES.EXTERNAL) {
      navigate("/");
    }
  }, [permissions, navigate, authToken]);

  // TODO: Make this all routes based
  useEffect(() => {
    if (permissions.role_type === AUTH_ROLES.NIAP) {
      setSelectedDashBoard("NIAP");
    } else if (permissions.role_type === AUTH_ROLES.VALIDATOR) {
      setSelectedDashBoard("Validator");
    } else if (permissions.role_type === AUTH_ROLES.VENDOR) {
      setSelectedDashBoard("Vendor");
    } else if (permissions.role_type === AUTH_ROLES.LAB) {
      setSelectedDashBoard("Lab");
    } else if (permissions.role_type === AUTH_ROLES.SME) {
      setSelectedDashBoard("SME");
    }
  }, [permissions, setSelectedDashBoard]);

  usePageTitle("NIAP - Community");

  return (
    <Box>
      <MemberPortalSubheader
        userName={currentUser?.first_name}
        selectedDashBoard={selectedDashBoard}
      />

      <Box sx={{ display: "flex", height: "100%" }}>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <StyledMain open={sidebarOpen}>
          {permissions.role_type !== AUTH_ROLES.VENDOR && <MemberBreadcrumbs />}
          <Outlet />
          {authToken && <LegacyRoutes selectedDashBoard={selectedDashBoard} />}
        </StyledMain>
      </Box>
    </Box>
  );
};

export default Admin;
